import React from 'react';
import { ReviewGroup } from './review-variations.styles';
import { Review } from '../../../molecules';

const renderReviewVariations = ({
  displayMode,
  count,
  score,
  allowEmptyRating,
  showRating,
  format
}) => {
  const shouldHideRating = !allowEmptyRating && !score;

  if (shouldHideRating || !showRating) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ReviewGroup, {
    displayMode: displayMode
  }, /*#__PURE__*/React.createElement(Review, {
    format: format,
    score: score,
    count: count,
    width: "12px",
    height: "12px"
  }));
};

export default renderReviewVariations;